import './card-list.scss';

/**
 * version    1.0
 * class      <type> (CardList)
 * classdesc
 */
export class CardList {}
